import ProcessGoalsPage from './ProcessGoalsPage';

export default ProcessGoalsPage;
